import React from 'react';
import './ShopDetails.css';
import CustomerHeader from '../../components/CustomerHeader';
import CustomerFooter from '../../components/CustomerFooter';

const CustomerProfile = () => {
  return (
    <>
      <CustomerHeader />
      <div className="customer-profile-page">
      <div className="placeholder-content">
        <h1>👤 My Profile</h1>
        <p className="coming-soon">Page coming soon...</p>
        <div className="placeholder-features">
          <div className="feature">✅ Personal information</div>
          <div className="feature">✅ Payment methods</div>
          <div className="feature">✅ Favorite shops & professionals</div>
          <div className="feature">✅ Booking preferences</div>
          <div className="feature">✅ Notifications settings</div>
          <div className="feature">✅ Account security</div>
        </div>
      </div>
    </div>
      <CustomerFooter />
    </>
  );
};

export default CustomerProfile;
